import * as React from 'react'

export type TabsValue = null | string

export type TabsOnChangeFunction = (value: TabsValue) => void

export interface ITabsContext {
  tabsValue: TabsValue
  onChange: TabsOnChangeFunction
}

export const TabsContext = React.createContext<ITabsContext>({
  tabsValue: null,
  onChange: () => {}
})
